export const getFileName = (responseHeader: any) => {
  return responseHeader["content-disposition"]
    .split(";")
    .find((n: string) => n.includes("filename="))
    .replace("filename=", "")
    .replaceAll('"', "")
    .trim();
};
